module.exports = __webpack_public_path__ + "static/NodeVersion-29e05ce04e656bfcf4432db85cecf1c1.png";